// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scheduledSection {
  height: calc(100vh - 630px);
  overflow-y: scroll;
  direction: rtl;
  padding-left: 12px;
}
.scheduledSection table {
  direction: ltr;
}
.scheduledSection table thead tr th {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
  font-family: "Poppins";
  line-height: 19.6px;
  font-weight: 400;
  border-bottom: none;
}
.scheduledSection table thead tr .header-cell.teledriver-header {
  width: 250px;
}
.scheduledSection table tbody .row-gap {
  height: 12px;
}
.scheduledSection table tbody tr.MuiTableRow-root .teledriverName {
  font-weight: 600;
  width: 250px;
}
.scheduledSection table tbody tr.MuiTableRow-root .taskName {
  width: 130px;
}
.scheduledSection table tbody tr.MuiTableRow-root .actionCell button:hover {
  background: none;
}
.scheduledSection table tbody tr.MuiTableRow-root .connectivity {
  width: 10%;
  text-align: center;
}
.scheduledSection table tbody tr.MuiTableRow-root td {
  border: none;
  margin-bottom: 12px;
  padding: 10px 16px;
  color: rgb(255, 255, 255);
  font-weight: 400;
  font-family: "Poppins";
  font-size: 14px;
  line-height: 22px;
  height: 50px;
}
.scheduledSection table tbody tr.MuiTableRow-root td .monitorButton {
  color: #fff;
  font-size: 14px;
  font-family: "Poppins";
  font-weight: 700;
  line-height: 22px;
  text-transform: capitalize;
  padding: 8px 6px;
}
.scheduledSection table tbody tr.MuiTableRow-root td .monitorButton .orange {
  color: rgb(255, 139, 30);
}
.scheduledSection table tbody tr.MuiTableRow-root td .monitorButton img {
  margin-left: 10px;
}
.scheduledSection table tbody tr.MuiTableRow-root td.teledriverButton button {
  background: rgb(47, 51, 72);
  width: 100%;
  padding: 0 14px;
  justify-content: left;
  text-transform: capitalize;
  color: rgb(255, 255, 255);
  font-size: 16px;
  line-height: 24px;
  font-weight: 500;
  border-radius: 10px;
  min-width: 314px;
  height: 50px;
}
.scheduledSection table tbody tr.MuiTableRow-root td.teledriverButton button .leftSection {
  display: flex;
  align-items: center;
}
.scheduledSection table tbody tr.MuiTableRow-root td.teledriverButton button .leftSection img {
  margin-right: 8px;
  border-radius: 50%;
  width: 30px;
  height: 30px;
}
.scheduledSection table tbody tr.MuiTableRow-root td.teledriverButton button .rightSection {
  display: flex;
  align-items: center;
}
.scheduledSection table tbody tr.MuiTableRow-root td.teledriverButton .hovered {
  border: 1px solid rgba(255, 255, 255, 0.2);
  background: rgb(53, 58, 82);
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.scheduledSection table tbody tr.MuiTableRow-root td.teledriverButton .hovered .leftSection {
  display: flex;
  align-items: center;
}
.scheduledSection table tbody tr.MuiTableRow-root td.teledriverButton .hovered .leftSection img {
  margin-right: 8px;
  border-radius: 50%;
  width: 30px;
  height: 30px;
}
.scheduledSection table tbody tr.MuiTableRow-root td:first-child {
  border-radius: 8px 0px 0px 8px;
  position: relative;
}
.scheduledSection table tbody tr.MuiTableRow-root td:first-child img {
  position: absolute;
  left: 0px;
  top: 0px;
}
.scheduledSection table tbody tr.MuiTableRow-root td:last-child {
  border-radius: 0px 8px 8px 0px;
  width: 5%;
  padding: 0px !important;
}`, "",{"version":3,"sources":["webpack://./src/components/Dashboard/RequestsSection/ScheduledSession/styles.scss"],"names":[],"mappings":"AAAA;EACI,2BAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;AACJ;AACI;EACI,cAAA;AACR;AAGgB;EACI,eAAA;EACA,+BAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;AADpB;AAIgB;EACI,YAAA;AAFpB;AAQY;EACI,YAAA;AANhB;AAUgB;EACI,gBAAA;EACA,YAAA;AARpB;AAWgB;EACI,YAAA;AATpB;AAaoB;EACI,gBAAA;AAXxB;AAegB;EACI,UAAA;EACA,kBAAA;AAbpB;AAgBgB;EACI,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,sBAAA;EACA,eAAA;EACA,iBAAA;EACA,YAAA;AAdpB;AAgBoB;EACI,WAAA;EACA,eAAA;EACA,sBAAA;EACA,gBAAA;EACA,iBAAA;EACA,0BAAA;EACA,gBAAA;AAdxB;AAgBwB;EACI,wBAAA;AAd5B;AAiBwB;EACI,iBAAA;AAf5B;AAqBoB;EACI,2BAAA;EACA,WAAA;EACA,eAAA;EACA,qBAAA;EACA,0BAAA;EACA,yBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;AAnBxB;AAqBwB;EACI,aAAA;EACA,mBAAA;AAnB5B;AAqB4B;EACI,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;AAnBhC;AAuBwB;EACI,aAAA;EACA,mBAAA;AArB5B;AAyBoB;EACI,0CAAA;EACA,2BAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AAvBxB;AAyBwB;EACI,aAAA;EACA,mBAAA;AAvB5B;AAyB4B;EACI,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;AAvBhC;AA6BgB;EACI,8BAAA;EACA,kBAAA;AA3BpB;AA6BoB;EACI,kBAAA;EACA,SAAA;EACA,QAAA;AA3BxB;AA+BgB;EACI,8BAAA;EACA,SAAA;EACA,uBAAA;AA7BpB","sourcesContent":[".scheduledSection {\r\n    height: calc(100vh - 630px);\r\n    overflow-y: scroll;\r\n    direction: rtl;\r\n    padding-left: 12px;\r\n\r\n    table {\r\n        direction: ltr;\r\n\r\n        thead {\r\n            tr {\r\n                th {\r\n                    font-size: 14px;\r\n                    color: rgba(255, 255, 255, 0.7);\r\n                    font-family: 'Poppins';\r\n                    line-height: 19.6px;\r\n                    font-weight: 400;\r\n                    border-bottom: none;\r\n                }\r\n\r\n                .header-cell.teledriver-header {\r\n                    width: 250px;\r\n                }\r\n            }\r\n        }\r\n\r\n        tbody {\r\n            .row-gap {\r\n                height: 12px;\r\n            }\r\n\r\n            tr.MuiTableRow-root {\r\n                .teledriverName {\r\n                    font-weight: 600;\r\n                    width: 250px;\r\n                }\r\n\r\n                .taskName {\r\n                    width: 130px;\r\n                }\r\n\r\n                .actionCell {\r\n                    button:hover {\r\n                        background: none;\r\n                    }\r\n                }\r\n\r\n                .connectivity {\r\n                    width: 10%;\r\n                    text-align: center;\r\n                }\r\n\r\n                td {\r\n                    border: none;\r\n                    margin-bottom: 12px;\r\n                    padding: 10px 16px;\r\n                    color: rgb(255, 255, 255);\r\n                    font-weight: 400;\r\n                    font-family: \"Poppins\";\r\n                    font-size: 14px;\r\n                    line-height: 22px;\r\n                    height: 50px;\r\n\r\n                    .monitorButton {\r\n                        color: #fff;\r\n                        font-size: 14px;\r\n                        font-family: 'Poppins';\r\n                        font-weight: 700;\r\n                        line-height: 22px;\r\n                        text-transform: capitalize;\r\n                        padding: 8px 6px;\r\n\r\n                        .orange {\r\n                            color: rgba(255, 139, 30, 1);\r\n                        }\r\n\r\n                        img {\r\n                            margin-left: 10px;\r\n                        }\r\n                    }\r\n                }\r\n\r\n                td.teledriverButton {\r\n                    button {\r\n                        background: rgba(47, 51, 72, 1);\r\n                        width: 100%;\r\n                        padding: 0 14px;\r\n                        justify-content: left;\r\n                        text-transform: capitalize;\r\n                        color: rgba(255, 255, 255, 1);\r\n                        font-size: 16px;\r\n                        line-height: 24px;\r\n                        font-weight: 500;\r\n                        border-radius: 10px;\r\n                        min-width: 314px;\r\n                        height: 50px;\r\n\r\n                        .leftSection {\r\n                            display: flex;\r\n                            align-items: center;\r\n\r\n                            img {\r\n                                margin-right: 8px;\r\n                                border-radius: 50%;\r\n                                width: 30px;\r\n                                height: 30px;\r\n                            }\r\n                        }\r\n\r\n                        .rightSection {\r\n                            display: flex;\r\n                            align-items: center;\r\n                        }\r\n                    }\r\n\r\n                    .hovered {\r\n                        border: 1px solid rgba(255, 255, 255, 0.2);\r\n                        background: rgba(53, 58, 82, 1);\r\n                        display: flex;\r\n                        align-items: center;\r\n                        justify-content: space-between;\r\n\r\n                        .leftSection {\r\n                            display: flex;\r\n                            align-items: center;\r\n\r\n                            img {\r\n                                margin-right: 8px;\r\n                                border-radius: 50%;\r\n                                width: 30px;\r\n                                height: 30px;\r\n                            }\r\n                        }\r\n                    }\r\n                }\r\n\r\n                td:first-child {\r\n                    border-radius: 8px 0px 0px 8px;\r\n                    position: relative;\r\n\r\n                    img {\r\n                        position: absolute;\r\n                        left: 0px;\r\n                        top: 0px;\r\n                    }\r\n                }\r\n\r\n                td:last-child {\r\n                    border-radius: 0px 8px 8px 0px;\r\n                    width: 5%;\r\n                    padding: 0px !important;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
